<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="vx-col w-full mt-base">
          <vs-card class="p2">
            <div slot="header">
              <div class="vx-row m-2">
                <h5>Data Credentials</h5>
              </div>
            </div>
            <form>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>Username</span>
                </div>
                <div class="vx-col sm:w-5/6 w-full">
                  <vs-input class="w-full" type="text" v-model="updateCredentials.username" name="username" v-validate="'required|min:5'"/>
                  <span class="text-danger text-sm" v-show="errors.has('username')">{{ errors.first('username') }}</span>
                  <span class="text-danger text-sm" v-show="!usernameStatus">{{' ' + usernameErrorMsg}}</span>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>Password</span>
                </div>
                <div class="vx-col sm:w-5/6 w-full">
                  <vs-input class="w-full" type="password" v-model="updateCredentials.password" name="password" v-validate="'required|min:8'"/>
                  <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col sm:w-5/6 w-full ml-auto">
                  <vs-button 
                    color="primary"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-check"
                    class="mb-4 self-end"
                    size="medium"
                    @click="submitCredentials()"
                    >Update Credentials
                  </vs-button>
                </div>
              </div>
            </form>
          </vs-card>
        </div>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/4">
        <vs-button
          @click="$router.push({name: 'manajemen-user-detail', params : {uuid : $route.params.uuid}})"
          color="primary"
          type="border"
          icon-pack="feather"
          icon="icon-arrow-left"
          class="mb-4 self-end"
          size="small"
          > Kembali
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import {FIND} from '@/query/pengguna';
import {UPDATE_CREDENTIAL} from '@/query/login';
import {CHECK_USERNAME} from '@/query/login';

export default {
  data() {
    return {
      pengguna : {},
      updateCredentials : {
        username : '',
        password : ''
      },
      usernameStatus : true,
      usernameErrorMsg : '',
      lock : ''
    };
  },
  mounted(){
    this.assignData();
  },
  apollo : {
    pengguna : {
      query : FIND,
      update : (data) => data.pengguna,
      variables(){
        return {
          where: { column : 'UUID', value : this.$route.params.uuid }
        }
      }
    }
  },
  methods : {
    async submitCredentials(){
      await this.$validator.validateAll().then(result => {
        if(result && this.usernameStatus) {
          this.$apollo.mutate({
            mutation : UPDATE_CREDENTIAL,
            variables : {
              id : this.pengguna.login.id,
              input : {
                username : this.updateCredentials.username,
                password : this.updateCredentials.password
              }
            }
          })
          .then(() => {
            this.$vs.notify({
              title: 'Berhasil melakukan update kredensial.',
              color: "success",
              iconPack: "feather",
              icon: "icon-check",
              position : "top-right"
            });
            window.setTimeout(() => {
              this.updateCredentials.password = '';
              this.$router.push({name : 'manajemen-user-detail',params : {uuid : this.$route.params.uuid}});
            },700);
          })
          .catch((error) => {
            console.log(error);
            if(error.graphQLErrors[0].extensions.validation.length() != 0){
              this.$vs.notify({
                title: error.graphQLErrors[0].extensions.validation,
                color: "danger",
                iconPack: "feather",
                icon: "icon-x",
                position : "top-right"
              });
            }
            else{
              console.error(error);
              this.$vs.notify({
                title: 'Terjadi kesalahan, silahkan hubungi tim IT.',
                color: "danger",
                iconPack: "feather",
                icon: "icon-x",
                position : "top-right"
              });
            }
          })
        }
        else{
          this.$vs.notify({
            title: 'Untuk memperbaharui data kredensial, silahkan lengkapi form terlebih dahulu !',
            color: "danger",
            iconPack: "feather",
            icon: "icon-x",
            position : "top-right"
          });
        }
      });
    },
    async checkUsername(){
      clearTimeout(this.lock);
      this.lock = setTimeout(() => {
        this.checkUsernameCharacters() == true ? this.checkUsernameAvailability() : '';
      }, 700);
    },
    checkUsernameCharacters(){
      var regex = /^[A-Za-z0-9 ]+$/;
      if(!regex.test(this.updateCredentials.username) || this.updateCredentials.username.indexOf(' ') >= 0){
        this.usernameStatus = false;
        this.usernameErrorMsg = 'Username tidak boleh berisi spasi & karakter spesial !';
        return false;
      }
      else{
        return true;
      }
    },
    checkUsernameAvailability(){
      this.$apollo.query({
      query : CHECK_USERNAME,
        variables : {
          id : this.pengguna.login.id,
          username : this.updateCredentials.username,
        }
      })
      .then((response) => {
        if(response.data.checkUsername != null){
          this.usernameStatus = false;
          this.usernameErrorMsg = 'Username sudah digunakan, silahkan masukan username yang lain !';
        }
        else{
          this.usernameStatus = true;
        }
      })
      .catch((error) => {
        console.error(error);
        this.$vs.notify({
          title: 'Terjadi kesalahan, silahkan hubungi tim IT.',
          color: "danger",
          iconPack: "feather",
          icon: "icon-x",
          position : "top-right"
        });
      });
    },
    assignData(){
      Object.assign(this.updateCredentials, this.pengguna.login);
    },
  },
  watch : {
    'updateCredentials.username' : function(){
      this.updateCredentials.username.length > 4 ? this.checkUsername() : '';
    },
  }
};
</script>
